'use client';

import * as React from 'react';
import { icons, type LucideProps } from 'lucide-react';
import { cn } from '@/lib/utils';

export type IconSize = 'sm' | 'md';

export interface IconProps {
  name: keyof typeof icons;
  size?: IconSize;
  className?: string;
}

const PIXELS: Record<IconSize, number> = {
  sm: 16,
  md: 20,
};

export function Icon({ name, size = 'sm', className }: IconProps) {
  const LucideIcon = icons[name] as React.ComponentType<LucideProps>;
  if (!LucideIcon) return null;
  const px = PIXELS[size];
  return (
    <LucideIcon
      width={px}
      height={px}
      strokeWidth={1.75}
      className={cn(className)}
      aria-hidden="true"
    />
  );
}
